import { HoneycombStyleSystemProps, useHoneycombTheme } from '../../../theming';

export function useCustomStyleProps(styleId?: string): HoneycombStyleSystemProps | null {
    const { customStyleProps } = useHoneycombTheme();
    if (!styleId) {
        return null;
    }
    return customStyleProps[styleId] ?? null;
}
